// extracted by mini-css-extract-plugin
export default {"zr-text":"Text_zr-text__NC1YI"};